import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuth } from './hooks/useAuth';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard/Dashboard';
import { CustomersPage } from './pages/Customers/Customers';
import { CustomerDetailsPage } from './pages/Customers/CustomerDetails';
import { OrdersPage } from './pages/Orders/Orders';
import { BookingsCalendarPage } from './pages/BookingsCalendar/BookingsCalendar';
import { BlockedDatesPage } from './pages/BlockedDates/BlockedDates';
import { FeaturesPage } from './pages/Features/Features';
import { InventoryPage } from './pages/Inventory/Inventory';
import { SettingsPage } from './pages/Settings/Settings';
import { DiscountCodesPage } from './pages/DiscountCodes/DiscountCodes';
import { NewsletterMarketingPage } from './pages/NewsletterMarketing/NewsletterMarketing';
import { LoadingSpinner } from './components/shared/LoadingSpinner';

function App() {
  const { isAuthenticated, isLoading, user, login, logout } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <LoginPage onLogin={login} />
        <Toaster position="top-right" />
      </>
    );
  }

  return (
    <BrowserRouter basename="/">
      <Layout onLogout={logout} user={user}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/bookings-calendar" element={<BookingsCalendarPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/:id" element={<CustomerDetailsPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/discount-codes" element={<DiscountCodesPage />} />
          <Route path="/newsletter" element={<NewsletterMarketingPage />} />
          <Route path="/blocked-dates" element={<BlockedDatesPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
